import appEvents from 'constants/appEvents.constant';
import mainEvents from 'modules/main/config/events.constant';

export default function BasketService(
    $rootScope,
    $window,
    $state,
    localStorageService,
    userService,
    authService,
    flightRecommendationService,
    flightSegmentService,
    flightGroupService,
    flightGroupDaysShiftArrivalService,
) {
    'ngInject';

    const BASKET_KEY = 'basket';
    const emptyBasket = {
        flightIds: {},
        flights: [],
        railIds: {},
        hotels: [],
        cars: [],
        rails: [],
        euRails: [],
        count: 0,
    };

    return {
        assignWatchers,
        assignBasketFromRootScopeToLocalStorage,
        getParamsToSearchForSuitableHotel,
        isFlightInBasket,
        getData: function() {
            return $rootScope.basket;
        },

        isEmpty: function() {
            return _.isEqual($rootScope.basket, emptyBasket);
        },

        getFlights: function() {
            return $rootScope.basket.flights;
        },

        getHotels: function() {
            return $rootScope.basket.hotels;
        },

                getCars: function() {
                    return $rootScope.basket.cars;
                },

        getRails: function() {
            return $rootScope.basket.rails;
        },
        getEuRails: function() {
            return $rootScope.basket.euRails;
        },
        clearBasket: function() {
                    $rootScope.basket = angular.copy(emptyBasket);
        },

        addCar: function(car, rentalPeriod, fareIndex) {
            if (authService.isTokenExpired()) {
                authService.logout();
                    return;
            }

            const pickUpDate = moment(car.PickupDate);
            const dropOffDate = moment(car.DropoffDate);

            const carObject = {
                carId: car.CarId,
                searchId: car.searchId,
                address: car.PickupAddress,
                pickUpCity: car.PickupCity,
                model: car.ModelName,
                category: car.Category,
                companyName: car.Company.Name,
                price: car.Fares[fareIndex].RequestedTotalPrice,
                carFareId: car.Fares[fareIndex].Id,
                pickUpDate: pickUpDate.toISOString(),
                dropOffDate: dropOffDate.toISOString(),
                diffDates: rentalPeriod,
            };

            $rootScope.basket.cars.push(carObject);
        },

        removeCar: function(index) {
            $rootScope.basket.cars.splice(index, 1);
        },

        addHotel: function(hotel, room, checkInDate, checkOutDate, rooms, searchId) {
            if (authService.isTokenExpired()) {
                authService.logout();

                return;
            }

            const regionalSettings = userService.getRegionalSettings();

            const checkIn = moment(checkInDate, regionalSettings.dateFormat);
            const checkOut = moment(checkOutDate, regionalSettings.dateFormat);

            const hotelObject = {
                searchId,
                hotelId: hotel.Id,
                roomId: room.Id,
                name: hotel.Name,
                address: hotel.Address,
                city: hotel.City,
                roomType: room.RoomType,
                price: room.RequestedPrice,
                rooms,
                //occupants: params.occupantsQuantity,
                checkInDate: checkIn.toISOString(),
                checkOutDate: checkOut.toISOString(),
                diffDates: checkOut.diff(checkIn, 'days'),
            };

            $rootScope.basket.hotels.push(hotelObject);
        },

        removeHotel: function(index) {
            $rootScope.basket.hotels.splice(index, 1);
        },

        addEurostar: function(flight, fare, flightGroups, params, searchId, isRoundtrip) {
            if (authService.isTokenExpired()) {
                authService.logout();

                return;
            }

            const segments = [];
            const groupIds = [];
            const totalPassengers = +params.Travelers.Adult.value + +params.Travelers.Child.value;

            angular.forEach(flightGroups, function(timeAlternativeIndex, segmentIndex) {
                const segment = angular.copy(flight.FlightSegments[segmentIndex]);
                const flightGroup = segment.FlightGroups[timeAlternativeIndex];

                const segmentObject = {
                        departureDate: flightGroup.Flights[0].DepartureDate,
                        arrivalDate: flightGroup.Flights[flightGroup.Flights.length - 1].ArrivalDate,
                        diffDays: flightGroup.daysShift,
                        duration: flightGroup.Duration,
                        canBeBooked: flightGroup.CanBeBooked,
                        flights: flightGroup.Flights,
                    };

                groupIds.push(flightGroup.FlightGroupId);
                segments.push(segmentObject);
            });

            const flightObject = {
                searchId,
                recommendationId: flight.RecommendationId,
                fareRecommendationId: fare.FareRecommendationGuid,
                groupIds,
                fastSearchId: flight.RecommendationId + fare.FareRecommendationGuid + groupIds.join(''),
                isRoundtrip,

                company: flight.MarketingCompanyName,
                price: fare.Price,
                seats: totalPassengers,
                infants: parseInt(params.Travelers.Infant.value, 10),
                travelers: {
                    adult: parseInt(params.Travelers.Adult.value, 10),
                    child: parseInt(params.Travelers.Child.value, 10),
                    infant: parseInt(params.Travelers.Infant.value, 10),
                },
                segments,
            };

            $rootScope.basket.flightIds[flightObject.fastSearchId] = true;
            $rootScope.basket.flights.push(flightObject);
        },

        addFlight: function(recommendation, fare, selectedFlights, params) {
            if (authService.isTokenExpired()) {
                authService.logout();

                return;
            }

            const groupIds = [];
            const totalPassengers = +params.Travelers.Adult.value + +params.Travelers.Child.value;

            const segments = recommendation.FlightSegments
                .map((segment) => flightSegmentService.getSelectedGroup(selectedFlights, segment))
                .map((group) => {
                    groupIds.push(group.FlightGroupId);
                    return {
                        departureDate: flightGroupService.getFirstFlight(group).DepartureDate,
                        arrivalDate: flightGroupService.getLastFlight(group).ArrivalDate,
                        diffDays: flightGroupDaysShiftArrivalService.getDayShiftArrival(group),
                        duration: group.Duration,
                        canBeBooked: group.CanBeBooked,
                        flights: group.Flights,
                    };
                });

            const flightObject = {
                searchId: params.SearchId,
                recommendationId: recommendation.RecommendationId,
                fareRecommendationId: fare.FareRecommendationGuid,
                groupIds,
                fastSearchId: recommendation.RecommendationId + fare.FareRecommendationGuid + groupIds.join(''),
                isRoundtrip: params.flightType === 'roundtrip',

                company: recommendation.MarketingCompanyName,
                price: fare.Price,
                seats: totalPassengers,
                infants: parseInt(params.Travelers.Infant.value, 10),
                travelers: {
                    adult: parseInt(params.Travelers.Adult.value, 10),
                    child: parseInt(params.Travelers.Child.value, 10),
                    infant: parseInt(params.Travelers.Infant.value, 10),
                },
                segments,
            };

            $rootScope.basket.flightIds[flightObject.fastSearchId] = true;
            $rootScope.basket.flights.push(flightObject);
        },

        removeFlight: function(index) {
            const flightObject = $rootScope.basket.flights[index];
            $rootScope.basket.flights.splice(index, 1);
            delete $rootScope.basket.flightIds[flightObject.fastSearchId];
        },
        addRail: function(rail) {
            if (authService.isTokenExpired()) {
                authService.logout();
                $state.go('login');
                return;
            }
            $rootScope.basket.railIds[rail.fastSearchId] = true;
            if (!$rootScope.basket.rails) {
                $rootScope.basket.rails = [];
            }
            $rootScope.basket.rails.push(rail);
        },
        removeRail: function(index) {
            const railObject = $rootScope.basket.rails[index];
            $rootScope.basket.rails.splice(index, 1);
            delete $rootScope.basket.railIds[railObject.fastSearchId];
        },
        addEuRail: function(euRail) {
            if (authService.isTokenExpired()) {
                authService.logout();
                $state.go('login');
                return;
            }
            if (!$rootScope.basket.euRails) {
                $rootScope.basket.euRails = [];
            }
            $rootScope.basket.euRails.push(euRail);
        },
        removeEuRail: function(index) {
            $rootScope.basket.euRails.splice(index, 1);
        },
        inBasket: function(itemType, item, fareId, flightGroups) {
            let items;
            let criteria;
            switch (itemType) {
                case 'flight':
                    items = this.getFlights();
                    return flightInBasket(item, fareId, flightGroups);
                case 'room':
                    items = this.getHotels();
                    criteria = {roomId: item.Id};
                    break;
                case 'car':
                    items = this.getCars();
                    criteria = {carId: item.CarId};
                    break;
                case 'rail':
                    items = this.getRails();
                    return railInBasket(item, fareId, flightGroups);
                default:
                    break;
            }
            return !!_.findWhere(items, criteria);
        },

        toggleBasket: function($scope) {
            if ($rootScope.readOnlyMode) {
                $state.go('login');
            }
            $scope.validation.visible = false;
            $scope.validation.messages.warnings = false;

            $scope.showBasket = !$scope.showBasket;
            $rootScope.$broadcast(mainEvents.TOGGLE_BASKET, $scope.showBasket);
        },
        toggleUserMenu: function($scope) {
            $scope.showUserMenu = !$scope.showUserMenu;
            $rootScope.$broadcast(mainEvents.TOGGLE_USER_MENU, $scope.showUserMenu);
        },
        // TODO: this method was returned back but it should be reimplemented.
        scrollBasketToBottom: function() {
            const BASKET_SELECTOR = '.basket-case';
            const BASKET_LIST_SELECTOR = '.list-basket-case';

            angular.element(BASKET_SELECTOR).animate({
                scrollTop: angular.element(BASKET_LIST_SELECTOR).height(),
            }, 'slow');
        }};

    function assignWatchers() {

        /**
         * Listen for changes from other tabs (needed to achieve synchronisation with all tabs)
         */
        angular.element($window)
            .on('storage',
                function() {
            $rootScope.$apply(function() {
                const basketData = getBasketFromLocalStorage();
                _.assign($rootScope.basket, basketData);
            });
        });

                if ($rootScope && $rootScope.$watchGroup) {
                    $rootScope.$watchGroup([
                        'basket.flights.length',
                        'basket.hotels.length',
                        'basket.cars.length',
                    'basket.rails.length',
                    'basket.euRails.length',
            ], updateLength);
                }
            }

    function updateLength() {
        const basket = $rootScope.basket;
        const items = [];
        _.filter(basket, function(i) {
            _.filter(i, function(item) {
                if (item.price > 0) {
                    items.push(item.price);
                }
            });
        });
        const total = items.reduce((val, val2) => val + val2, 0);
        $rootScope.basketTotal = total.toFixed(2);
        $rootScope.basket.count = basket.flights.length + basket.hotels.length + basket.cars.length + basket.rails.length + basket.euRails.length;
        $rootScope.$broadcast(appEvents.UPDATE_BASKET_VALIDATION);
    }

    function railInBasket(railToCheck, fareId, railGroups) {
        const groupIds = [];

        angular.forEach(railGroups,
            function(timeAlternativeIndex, segmentIndex) {
                const segment = angular.copy(railToCheck.RailSegments[segmentIndex]);
                const railGroup = segment.RailGroups[timeAlternativeIndex];

                groupIds.push(railGroup.RailGroupId);
            });

        return $rootScope.basket.railIds[railToCheck.RecommendationId + fareId + groupIds.join('')];
    }

    function flightInBasket(flightToCheck, fareId, flightGroups) {
        const groupIds = [];

        angular.forEach(flightGroups, function(timeAlternativeIndex, segmentIndex) {
            const segment = angular.copy(flightToCheck.FlightSegments[segmentIndex]);
            if (segment) {
                const flightGroup = segment.FlightGroups[timeAlternativeIndex];
                if (flightGroup) {
                    groupIds.push(flightGroup.FlightGroupId);
                }
            }
        });

        return $rootScope.basket.flightIds[flightToCheck.RecommendationId + fareId + groupIds.join('')];
    }

    function isFlightInBasket(recommendation, fare, selectedFlights) {
        const groupIds = flightRecommendationService
            .getSelectedGroupsInRecommendation(recommendation, selectedFlights)
            .map(({FlightGroupId}) => FlightGroupId)
            .join('');

        const recommendationId = recommendation.RecommendationId;
        const fareId = fare.FareRecommendationGuid;
        const key = `${recommendationId}${fareId}${groupIds}`;

        return $rootScope.basket.flightIds[key];
    }

    function assignBasketFromRootScopeToLocalStorage() {
        if (localStorageService && localStorageService.bind) {
            localStorageService.bind($rootScope, BASKET_KEY, getBasketFromLocalStorage());
            $rootScope.basket.flightIds = $rootScope.basket.flightIds || {};
        $rootScope.basket.railIds = $rootScope.basket.railIds || {};
}
    }

    function getBasketFromLocalStorage() {
        const basketFromStorage = localStorageService.get(BASKET_KEY) || {};
const storageKeys = Object.keys(basketFromStorage);
const initKeys = Object.keys(emptyBasket);
const differenceKeys = _.difference(initKeys, storageKeys);
differenceKeys.forEach((key) => basketFromStorage[key] = angular.copy(emptyBasket[key]));
return basketFromStorage;
    }

    function getParamsToSearchForSuitableHotel() {
        const basket = $rootScope.basket.flights || [];

        const roundtrips = basket.filter(({isRoundtrip, segments}) => isRoundtrip && segments.length === 2);
        const oneways = basket.filter(({isRoundtrip}) => !isRoundtrip);

        if (roundtrips.length !== 1 && oneways.length !== 2) {
            return false;
        }

        return roundtrips.length
            ? checkAbility(processRoundtrip(roundtrips[0]))
            : checkAbility(processOneways(oneways));

        function processRoundtrip({segments, travelers}) {
            const [segment1, segment2] = segments;
        const originDirect = mergeToDirect(segment1.flights);
        const destinationDirect = mergeToDirect(segment2.flights);

        Object.assign(originDirect, {travelers});
        Object.assign(destinationDirect, {travelers});

        return [originDirect, destinationDirect];
    }

    function processOneways(flights) {
        return flights
            .map(({segments, travelers}) => {
                const [segment] = segments;
                const direct = mergeToDirect(segment.flights);
                return Object.assign(direct, {travelers});
            })
            .sort((one, another) => new Date(one.DepartureDate) - new Date(another.DepartureDate));
    }
}

    function mergeToDirect(flights) {
        if (!flights.length) {
            return {};
        }
        if (flights.length === 1) {
            return flights[0];
        }

        const [originAndStop] = flights;
        const stopAndDestination = flights[flights.length - 1];
        return {
            DepartureCity: originAndStop.DepartureCity,
            DepartureCountryCode: originAndStop.DepartureCountryCode,
            DepartureDate: originAndStop.DepartureDate,
            ArrivalCity: stopAndDestination.ArrivalCity,
            ArrivalCountryCode: stopAndDestination.ArrivalCountryCode,
            ArrivalDate: stopAndDestination.ArrivalDate,
            travelers: originAndStop.travelers,
        };
    }

    function checkAbility([first, second]) {
        const city = first.ArrivalCity;
        const countryCode = first.ArrivalCountryCode;
        const fromDate = first.ArrivalDate;
        const toDate = second.DepartureDate;
        const travelers = first.travelers;

        return city === second.DepartureCity
            && countryCode === second.DepartureCountryCode
            && getDateWithoutTime(fromDate) < getDateWithoutTime(toDate)
            && angular.equals(first.travelers, second.travelers)
            && {city, countryCode, fromDate, toDate, travelers};

        function getDateWithoutTime(dateString) {
            const date = new Date(dateString);
            return date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/services/basketService.js